module.exports = __webpack_public_path__ + "img/logo-theChalotte.682d4e70.png";